import { Input, LabeledLine } from "@touche-lts/panel-ui/dist";
import { StoreDTO } from "models";
import DescriptionInputWrapper from "../DescriptionInputWrapper";
import styles from "../add-store-page.module.scss";
import shopifyDetailStyles from "./shopify-detail.module.scss";

interface ShopifyDetailProps {
  integrationType: "old" | "new";
  store: StoreDTO;
  onStorePropsChange: (props: Partial<StoreDTO>) => void;
  validationErrors?: Record<string, string[]>;
}

const ShopifyDetail = ({
  integrationType,
  store,
  onStorePropsChange,
  validationErrors = {},
}: ShopifyDetailProps) => {
  return (
    <div>
      {/* Shopify Store URL - Common for both flows */}
      <LabeledLine className={styles.inputLine} label="Shopify Store URL">
        <DescriptionInputWrapper description="Can be found in store settings">
          <Input
            className={styles.input}
            placeholder="Shopify Store URL"
            autoComplete="off"
            autoCapitalize="none"
            type="url"
            value={store.shopifyStoreUrl}
            onChange={(shopifyStoreUrl) =>
              onStorePropsChange({ shopifyStoreUrl })
            }
            errorMessage={validationErrors?.shopifyStoreUrl?.[0]}
          />
        </DescriptionInputWrapper>
      </LabeledLine>

      {/* Old Integration Fields */}
      {integrationType === "old" && (
        <>
          <LabeledLine
            className={styles.inputLine}
            label="Admin API access token"
          >
            <div className={shopifyDetailStyles.inputWrapper}>
              <DescriptionInputWrapper
                description={`Can be found in "Admin API access token" section`}
              >
                <Input
                  className={styles.input}
                  placeholder="Admin API access token"
                  autoComplete="off"
                  autoCapitalize="none"
                  type="text"
                  value={store.shopifyAccessToken}
                  onChange={(shopifyAccessToken) =>
                    onStorePropsChange({ shopifyAccessToken })
                  }
                  errorMessage={validationErrors?.shopifyAccessToken?.[0]}
                />
              </DescriptionInputWrapper>
            </div>
          </LabeledLine>
          <LabeledLine className={styles.inputLine} label="Store API key">
            <DescriptionInputWrapper
              description={`Can be found in "API key and secret key" section`}
            >
              <Input
                className={styles.input}
                placeholder="Store API key"
                autoComplete="off"
                autoCapitalize="none"
                type="text"
                value={store.shopifySecretKey}
                onChange={(shopifySecretKey) =>
                  onStorePropsChange({ shopifySecretKey })
                }
                errorMessage={validationErrors?.shopifySecretKey?.[0]}
              />
            </DescriptionInputWrapper>
          </LabeledLine>
          <LabeledLine
            className={styles.inputLine}
            label="Shopify Storefront Token"
          >
            <DescriptionInputWrapper
              description={`Can be found in "Storefront API access token" section`}
            >
              <Input
                className={styles.input}
                placeholder="Shopify Storefront Token"
                autoComplete="off"
                autoCapitalize="none"
                type="text"
                value={store.shopifyStorefrontToken}
                onChange={(shopifyStorefrontToken) =>
                  onStorePropsChange({ shopifyStorefrontToken })
                }
                errorMessage={validationErrors?.shopifyStorefrontToken?.[0]}
              />
            </DescriptionInputWrapper>
          </LabeledLine>
        </>
      )}

      {/* New Integration Fields */}
      {integrationType === "new" && (
        <>
          <LabeledLine className={styles.inputLine} label="Store API key">
            <DescriptionInputWrapper
              description={`Can be found in "API key and secret key" section`}
            >
              <Input
                className={styles.input}
                placeholder="Store API key"
                autoComplete="off"
                autoCapitalize="none"
                type="text"
                value={store.shopifySecretKey}
                onChange={(shopifySecretKey) =>
                  onStorePropsChange({ shopifySecretKey })
                }
                errorMessage={validationErrors?.shopifySecretKey?.[0]}
              />
            </DescriptionInputWrapper>
          </LabeledLine>
          <LabeledLine className={styles.inputLine} label="Client ID">
            <DescriptionInputWrapper
              description={`Can be found in your Shopify app settings`}
            >
              <Input
                className={styles.input}
                placeholder="Client ID"
                autoComplete="off"
                autoCapitalize="none"
                type="text"
                value={store.clientId}
                onChange={(clientId) => onStorePropsChange({ clientId })}
                errorMessage={validationErrors?.clientId?.[0]}
              />
            </DescriptionInputWrapper>
          </LabeledLine>
        </>
      )}
    </div>
  );
};

export { ShopifyDetail };
